import React, { Component } from 'react'
import { withRadium, DetectCompact, gtmEvent } from 'higher-order-components'
import PropTypes from 'prop-types'
import {
  HeadingBlock,
  Ribbon,
  SpecificationList,
  ImageDisclaimer,
  FixedBar,
  MapLocationContainer
} from 'containers'
import { SummaryWithPrice, Slideshow, Hyperlink } from 'components'
import { Button, Tag, Space, Interactive, Caption, Section } from 'AtomicComponents'
import NavigationBar from 'containers/outlet-store/navigation-bar'
import queryString from 'query-string'
import { fetchKoalaData } from 'apis/koala'
import { gtmOutletStoreActionTypes } from 'store/gtm-events'
import AccessoriesCategory from './accessories-category'

class OutletDetail extends Component {
  constructor() {
    super()
    this.state = {
      mapBlockHeight: '500px',
      specs: {
        categories: []
      }
    }
  }
  componentDidMount() {
    const { specsApiEndpoint, data: { modelCode } } = this.props
    const options = {
      modelCode,
      featured: true // this is for getting featured specs, not related to the featured car prop
    }
    fetchKoalaData(specsApiEndpoint, options)
      .then((specs) => {
        this.setState({ specs: specs || false })
      })
      .catch(error => console.warn(error))
  }
  renderRego = (registrationNumber, registrationExpiryDate) => (
    <div>
      {registrationNumber}
      <span style={{ margin: '0 .5em', color: '#aaa' }}>|</span>
      {'Expires '}
      {!!registrationExpiryDate &&
        'JanFebMarAprMayJunJulAugSepOctNovDec'.match(/.{1,3}/g)[
        registrationExpiryDate.slice(-2) - 1
        ] +
        ' ' +
        registrationExpiryDate.slice(0, 4)}
    </div>
  )

  render() {
    const {
      compact,
      note,
      preHeading,
      heading,
      dealer,
      nameplateImage,
      stockTileBackgroundUrl,
      primaryCta,
      outletUrl,
      fullSpecificationsUrl,
      imageDisclaimer,
      dealerInfoDescription = 'To reserve this car, please call this dealer or enquire now.',
      data: {
        image,
        interiorImage,
        interiorTitle,
        colourDescription,
        nameplate,
        bodyStyle,
        vin,
        odometer,
        storeType,
        storeTypeCategory,
        registrationExpiryDate,
        registrationNumber,
        grade,
        driveTrain,
        engineSize,
        fuelType,
        transmissionType,
        price,
        accessories = [],
        disclaimer,
        stockNumber,
        featured,
        generation
      }
    } = this.props
    const toOutletHref = params => `${outletUrl}?${queryString.stringify(params)}`
    const toFormHref = params => `${primaryCta.href}?${queryString.stringify(params)}`

    const slideshowItems = [
      {
        src: image,
        type: 'Exterior',
        label: colourDescription,
        disclaimer: imageDisclaimer || 'For illustration purposes only',
        backgroundImage: stockTileBackgroundUrl,
        gtmEvents: [
          {
            func: this.props.gtmEvent,
            args: [
              {
                gtmID: gtmOutletStoreActionTypes.SLIDESHOW_INTERACTION_DETAIL,
                gtmPayload: {
                  nameplate,
                  bodyStyle,
                  storeTypeCategory,
                  grade,
                  imageLabel: 'Exterior Image 1'
                }
              }
            ]
          }
        ]
      },
      {
        src: image,
        type: 'Interior',
        backgroundImage: interiorImage,
        label: interiorTitle,
        disclaimer: imageDisclaimer || 'For illustration purposes only',
        gtmEvents: [
          {
            func: this.props.gtmEvent,
            args: [
              {
                gtmID: gtmOutletStoreActionTypes.SLIDESHOW_INTERACTION_DETAIL,
                gtmPayload: {
                  nameplate,
                  bodyStyle,
                  storeTypeCategory,
                  grade,
                  imageLabel: 'Interior Image 1'
                }
              }
            ]
          }
        ]
      }
    ]

    const gtmTags = category => ({
      ...category,
      gtmEvents: {
        expand: [
          {
            func: this.props.gtmEvent,
            args: [
              {
                gtmID: gtmOutletStoreActionTypes.EXPAND_ACCORDION_DETAIL,
                gtmPayload: {
                  nameplate,
                  bodyStyle,
                  storeTypeCategory,
                  grade,
                  sectionTitle: category.name
                }
              }
            ]
          }
        ],
        collapse: [
          {
            func: this.props.gtmEvent,
            args: [
              {
                gtmID: gtmOutletStoreActionTypes.COLLAPSE_ACCORDION_DETAIL,
                gtmPayload: {
                  nameplate,
                  bodyStyle,
                  storeTypeCategory,
                  grade,
                  sectionTitle: category.name
                }
              }
            ]
          }
        ]
      }
    })

    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Section padding>
          <HeadingBlock margin={false} textAlign={'center'} preHeading={preHeading} value={heading} />
          <div
            style={{
              display: compact[0] ? 'block' : 'flex',
              margin: '4em 0',
              justifyContent: 'space-between',
              width: "100%"
            }}>
            <div style={{ flex: '0 1 62%', textAlign: 'center' }}>
              <Slideshow
                gtmEventsByIndex={slideshowItems.map(({ gtmEvents }) => gtmEvents)}
                showBullets
                bulletsBelow>
                {slideshowItems.map(({ src, backgroundImage, label, disclaimer, type }, index) => (
                  <div
                    key={index}
                    style={[
                      { position: 'relative', marginBottom: '1em' },
                      backgroundImage
                        ? {
                          backgroundImage: `url(${backgroundImage})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center bottom'
                        }
                        : null
                    ]}>
                    {featured && <Ribbon text={'Featured'} backgroundColor={'#910A2D'} />}
                    <ImageDisclaimer
                      content={
                        <div
                          data-test={type.toLowerCase()}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            color: '#fff ',
                            flexDirection: compact[0] ? 'column' : 'row'
                          }}>
                          <Interactive>
                            <span style={{ color: '#fff' }}>{label}</span>
                          </Interactive>
                          <Caption>{disclaimer}</Caption>
                        </div>
                      } />
                    <img
                      src={src}
                      style={{
                        width: '100%',
                        display: 'block',
                        padding: compact[0] ? '2.5em 0 3.5em' : '4em 0 2em', // push the image up in compact to have space for disclaimer
                        opacity: type === 'Interior' && 0
                      }} />
                  </div>
                ))}
              </Slideshow>
            </div>
            <div
              style={{
                flex: '0 1 30%',
                order: '-1',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '0 auto'
              }}>
              <Tag color={storeType === 0 ? 'orange' : 'blue'}>{storeTypeCategory || (storeType === 1 ? 'Clearance' : 'Demo')}</Tag>
              <Space />
              <SummaryWithPrice
                disableBase
                heading={nameplate + ' ' + bodyStyle}
                previousGeneration={generation === 'Previous'}
                price={{
                  message: `Delivered price in ${this.props.dealer.state}`,
                  price,
                  disclaimer
                }}
                gtm={{
                  category: "Outlet Store",
                  action: `Vehicle Details Page - "${nameplate.toUpperCase()} ${bodyStyle.toUpperCase()}", "${storeTypeCategory.toUpperCase()}", "${grade.toUpperCase()}" - Clicked "PRICE DISCLAIMER"`
                }}
                items={[
                  { label: 'Grade', value: grade, border: true },
                  {
                    label: 'Drive & Transmission',
                    value: driveTrain + ' ' + transmissionType
                  },
                  { label: 'Engine', value: engineSize + ' ' + fuelType },
                  !storeType && { label: 'VIN', value: vin, border: true },
                  !!odometer && {
                    label: 'Odometer',
                    value: odometer.toLocaleString('nz') + 'km'
                  },
                  !storeType && {
                    label: 'Registration',
                    value: this.renderRego(
                      registrationNumber.toUpperCase(),
                      registrationExpiryDate
                    )
                  }
                ].filter(Boolean)} />
            </div>
          </div>
          <div
            style={{
              width: '90%',
              margin: '0 auto',
              textAlign: 'center'
            }}>
            {!!accessories.length && (
              <AccessoriesCategory
                accessories={accessories}
                gtmEvents={{
                  expand: [
                    {
                      func: this.props.gtmEvent,
                      args: [
                        {
                          gtmID: gtmOutletStoreActionTypes.EXPAND_ACCORDION_DETAIL,
                          gtmPayload: {
                            nameplate,
                            bodyStyle,
                            storeTypeCategory,
                            grade,
                            sectionTitle: `Fitted Accessories (${accessories.length})`
                          }
                        }
                      ]
                    }
                  ],
                  collapse: [
                    {
                      func: this.props.gtmEvent,
                      args: [
                        {
                          gtmID: gtmOutletStoreActionTypes.COLLAPSE_ACCORDION_DETAIL,
                          gtmPayload: {
                            nameplate,
                            bodyStyle,
                            storeTypeCategory,
                            grade,
                            sectionTitle: `Fitted Accessories (${accessories.length})`
                          }
                        }
                      ]
                    }
                  ]
                }} />
            )}
            {!!this.state.specs &&
              !!this.state.specs.categories.length && (
                <SpecificationList specs={this.state.specs.categories.map(gtmTags)} />
              )}
          </div>
          {fullSpecificationsUrl && (
            <div style={{ textAlign: 'right', width: "80%", margin: "0px auto", padding: '1em 0' }}>
              <Hyperlink
                href={fullSpecificationsUrl}
                gtmEvents={[
                  {
                    func: this.props.gtmEvent,
                    args: [
                      {
                        gtmID: gtmOutletStoreActionTypes.CLICK_FULL_SPECS_DETAIL,
                        gtmPayload: {
                          nameplate,
                          bodyStyle,
                          storeTypeCategory,
                          grade,
                          buttonText: `Explore full ${nameplate} specifications`
                        }
                      }
                    ]
                  }
                ]}>
                Explore full {nameplate} specifications ›
              </Hyperlink>
            </div>
          )}
          <p
            style={{
              fontSize: '90%',
              color: '#999999',
              fontWeight: 200,
              textAlign: 'center'
            }}>
            {note}
          </p>
        </Section>
        <div>
          <MapLocationContainer
            mapFixHeight
            searchType="nothing"
            scrollToMain={false}
            showScrollbars={false}
            locations={[dealer].map(item => ({
              ...item,
              customDealerDescription: dealerInfoDescription
            }))} />
        </div>
        {compact[1] ? (
          <FixedBar>
            <div style={{ padding: compact[0] ? '0 0 0 1em' : '0 1em' }}>
              <Button
                label={'BACK'}
                href="javascript:history.back()"
                styleName="blackOutlined"
                display="inline" />
            </div>
            <div style={{ padding: '0 1em' }}>
              <Button
                {...primaryCta}
                // Append params to the link to lead form
                href={toFormHref({
                  dealerCode: dealer.dealerCode,
                  locationId: dealer.id,
                  stockNumber: stockNumber,
                  nameplate
                })} />
            </div>
          </FixedBar>
        ) : (
            <NavigationBar
              compact={compact[0]}
              dealerButton={{
                selectionLabel: 'Step 1',
                selectedText: dealer.name,
                href: toOutletHref({
                  nameplate,
                  dealerCode: 'reset',
                  previousDealer: dealer.name
                })
              }}
              nameplateButton={{
                selectionLabel: 'Step 2',
                selectedText: nameplate,
                image: nameplateImage,
                href: toOutletHref({
                  dealerCode: dealer.dealerCode,
                  locationId: dealer.id
                })
              }}
              backButton={{
                label: 'BACK',
                href: toOutletHref({
                  nameplate,
                  step: 2
                })
              }}
              gtmEvents={{
                editDealer: [
                  {
                    func: this.props.gtmEvent,
                    args: [
                      {
                        gtmID: gtmOutletStoreActionTypes.EDIT_DEALER,
                        gtmPayload: {
                          buttonText: 'Edit',
                          dealerName: dealer.name
                        }
                      }
                    ]
                  }
                ],
                editNameplate: [
                  {
                    func: this.props.gtmEvent,
                    args: [
                      {
                        gtmID: gtmOutletStoreActionTypes.EDIT_MODEL,
                        gtmPayload: { buttonText: 'Edit', nameplate }
                      }
                    ]
                  }
                ],
                selectBack: [
                  {
                    func: this.props.gtmEvent,
                    args: [
                      {
                        gtmID: gtmOutletStoreActionTypes.CLICK_BACK_DETAIL,
                        gtmPayload: {
                          buttonText: 'BACK'
                        }
                      }
                    ]
                  }
                ],
                selectNext: [
                  {
                    func: this.props.gtmEvent,
                    args: [
                      {
                        gtmID: gtmOutletStoreActionTypes.CLICK_NEXT_DETAIL,
                        gtmPayload: {
                          nameplate,
                          bodyStyle,
                          storeTypeCategory,
                          grade,
                          dealerName: dealer.name,
                          hasAccessories: accessories.length ? 'Yes' : 'No',
                          fittedAccessories: accessories.length
                            ? accessories.map(({ description }) => description).join(',')
                            : '',
                          buttonText: primaryCta.label
                        }
                      }
                    ]
                  }
                ]
              }}
              nextButton={{
                ...primaryCta,
                ...{
                  // Append params to the link to lead form
                  href: toFormHref({
                    dealerCode: dealer.dealerCode,
                    locationId: dealer.id,
                    stockNumber: stockNumber,
                    nameplate
                  })
                }
              }} />
          )}
      </div>
    )
  }
}

OutletDetail.propTypes = {
  preHeading: PropTypes.string,
  heading: PropTypes.string,
  nameplateImage: PropTypes.string,
  stockTileBackgroundUrl: PropTypes.string,
  note: PropTypes.string,
  compact: PropTypes.arrayOf(PropTypes.bool),
  dealer: PropTypes.object,
  primaryCta: PropTypes.object,
  outletUrl: PropTypes.string,
  fullSpecificationsUrl: PropTypes.string,
  specsApiEndpoint: PropTypes.string,
  imageDisclaimer: PropTypes.string,
  gtmEvent: PropTypes.func,
  dealerInfoDescription: PropTypes.string,
  data: PropTypes.shape({
    image: PropTypes.string,
    nameplate: PropTypes.string,
    bodyStyle: PropTypes.string,
    storeType: PropTypes.number.isRequired,
    storeTypeCategory: PropTypes.string,
    registrationExpiryDate: PropTypes.string,
    registrationNumber: PropTypes.string,
    grade: PropTypes.string,
    modelCode: PropTypes.string,
    driveTrain: PropTypes.string,
    engine: PropTypes.string,
    price: PropTypes.number,
    accessories: PropTypes.array,
    disclaimer: PropTypes.string,
    stockNumber: PropTypes.number,
    generation: PropTypes.string
  })
}

OutletDetail.defaultProps = {
  specsApiEndpoint: '/api/configurator-outlet-spec'
}

export default withRadium(gtmEvent(), DetectCompact({ threshold: [768, 900] }))(OutletDetail)



// WEBPACK FOOTER //
// ./src/containers/outlet-store-detail/index.jsx